module.exports = __webpack_public_path__ + "static/media/theTrapK.1786da08.svg";